<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-large-size-60 md-medium-size-80 md-xlarge-size-50 md-size-100 px-0 flex items-center"
    >
      <information :information="information"></information>
    </div>
    <!--    <div class="md-layout-item px-0 max-w-[320px] pt-4 mr-3">-->
    <!--      <div class="chart-container max-w-[330px]" v-if="chartData">-->
    <!--        <div class="chart-content text-left max-w-[330px]">-->
    <!--          <p class="text-center text-[19px] font-medium">-->
    <!--            {{ $t("zoom_meeting.report_present") }}-->
    <!--          </p>-->
    <!--          <p class="text-center text-[19px] font-medium">{{ present }}</p>-->
    <!--        </div>-->
    <!--        <doughnut-chart-->
    <!--          :key="cpmKey"-->
    <!--          :chartData="chartData"-->
    <!--          class="h-[330px]"-->
    <!--        ></doughnut-chart>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import DoughnutChart from "../../Components/DoughnutChart/index";
import Information from "./Information";
import { listCardInformation } from "../../Components/ultils";

export default {
  props: ["staticInfo"],
  components: { Information },
  data() {
    return {
      chartData: null,
      componentKey: null,
      information: null,
      present: "",
      cpmKey: null
    };
  },

  watch: {
    staticInfo: function(newVal) {
      if (!newVal) return;
      this.setData(newVal);
    }
  },

  methods: {
    setData(staticInfo) {
      const { chart, data } = staticInfo;
      this.setInformation(data);
      this.setDataChart(chart);
    },
    setInformation(info) {
      this.information = listCardInformation(info);
    },
    setDataChart(chart) {
      this.present = chart.present.toFixed(2) + "%";
      let absence = (100 - chart.present.toFixed(2)).toFixed(2) + "%";
      this.chartData = {
        labels: [
          this.$t("zoom_meeting.absence") + " " + absence,
          this.$t("zoom_meeting.present") + " " + this.present
        ],
        datasets: [
          {
            backgroundColor: ["#F3DEF7", "#BD79C9"],
            data: [chart.absence, chart.present]
          }
        ]
      };
      this.cpmKey++;
    }
  }
};
</script>
<style lang="scss" scoped>
.chart-container {
  position: relative;
}
.chart-content {
  display: inline;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, calc(-50% - 16px));
}
</style>
